import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonApi } from '../+api';
import { ConceptInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class ConceptService {
  constructor(private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<ConceptInterface[]> {
    return this.personApi
      .getData(userId, 'concepts')
      .pipe(map((res: { concepts: ConceptInterface[] }) => res.concepts));
  }
}
